<script>
import { CarouselItem } from 'element-ui';
const CarouselItemWrapper = CarouselItem;
export default CarouselItemWrapper;
</script>
